<script>
	import { Router, Route } from "svelte-navigator";
	import { ApolloClient, InMemoryCache } from "@apollo/client";
	import { setClient } from "svelte-apollo";
	import './i18n.js'

	import Layers from '/Layers.svelte'
	import Analytics from '/Atoms/Analytics.svelte'

	export let url = "";

	console.log(`GraphQL Server URL: ${process.env.GRAPHQL_URL}`)

	// 1. Create an Apollo client and pass it to all child components
	//    (uses svelte's built-in context)
	const client = new ApolloClient({
		uri: process.env.GRAPHQL_URL,
		cache: new InMemoryCache(),
		headers: {
			authorization: 'Bearer ' + process.env.GRAPHQL_BEARER_TOKEN
		}
	});
	setClient(client);

	// <Router primary={false} url="{url}">

</script>

<Router url="{url}">
	<Route path="de/*">
		<Layers />
	</Route>
	<Route path="*">
		<Layers />
	</Route>
	<Analytics />
</Router>

<svelte:head>
	{#if process.env.SHOW_PENDING}
		<meta name="robots" content="noindex">
	{/if}
</svelte:head>

<style global src="./scss/global.scss" >
</style>